import ipConfig from "./ipConfig.json";
import { useParams } from "react-router-dom";
import { Route, Routes} from "react-router-dom";
import './App.css';
import LandingPage from './components/LandingPage';
import VideoPlay from "./components/VideoPlay";
export const config = {
  endpoint: `https://e5b8d403-e7ce-4f91-98e1-c2324e5cbca3.mock.pstmn.io/v1`,
};
function App() {

 
  return (
    <div className="App">
      
      <Routes>
          
          <Route  path= "/video/:_id" element={<VideoPlay/>} />
          <Route  exact path="/" element={<LandingPage/>} />

      </Routes>

      
    </div>
  );
}

export default App;

